import { Link } from 'react-router-dom';

export function NotFoundPage({ what = 'page' }: { what?: string }) {
  return (
    <div className="gsl-panel mx-auto max-w-xl px-6 py-8 text-center">
      <p className="gsl-display text-2xl">Not found</p>
      <p className="mt-3 text-sm text-muted-foreground">
        That {what} does not exist, or you do not have access to it. If you followed a link from Oracle, check the record
        number and try again.
      </p>
      <Link to="/" className="gsl-link mt-4 inline-block text-sm">
        Back to home
      </Link>
    </div>
  );
}
